/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * Clovie API
 * Salon management API
 * OpenAPI spec version: 0.0.1
 */
import { useInfiniteQuery, useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type {
  DeleteClientsId200,
  GetClients200,
  GetClientsClientIdGiftCards200,
  GetClientsExportParams,
  GetClientsGohighlevelImports200,
  GetClientsGohighlevelTags200,
  GetClientsId200,
  GetClientsIdCardOnFile200,
  GetClientsIdCounterPerks200,
  GetClientsIdCounterPerks403,
  GetClientsIdCreator200,
  GetClientsIdLoyalty200,
  GetClientsIdLoyalty403,
  GetClientsIdLoyalty404,
  GetClientsIdParams,
  GetClientsIdReferrals200,
  GetClientsIdReviewStatus200,
  GetClientsIdSplitCandidates200,
  GetClientsIds200,
  GetClientsIdsParams,
  GetClientsParams,
  GetClientsPhoneProfiles200,
  GetClientsPhoneProfilesParams,
  GetClientsPicker200,
  GetClientsPickerParams,
  GetClientsPosImports200,
  GetClientsQuickFilterCounts200,
  PatchClientsId200,
  PatchClientsIdBody,
  PostClients201,
  PostClientsBody,
  PostClientsGohighlevelImports201,
  PostClientsGohighlevelImportsBatchIdComplete200,
  PostClientsGohighlevelImportsBatchIdDoNotDisturb200,
  PostClientsGohighlevelImportsBatchIdDoNotDisturb409,
  PostClientsGohighlevelImportsBatchIdDoNotDisturbBody,
  PostClientsGohighlevelImportsBatchIdRows200,
  PostClientsGohighlevelImportsBatchIdRows400,
  PostClientsGohighlevelImportsBatchIdRows409,
  PostClientsGohighlevelImportsBatchIdRowsBody,
  PostClientsGohighlevelImportsBatchIdUndo200,
  PostClientsGohighlevelImportsBody,
  PostClientsGohighlevelImportsPreviewMatch200,
  PostClientsGohighlevelImportsPreviewMatchBody,
  PostClientsIdCounterPerksKindUse200,
  PostClientsIdCounterPerksKindUse403,
  PostClientsIdCounterPerksKindUse409,
  PostClientsIdCounterPerksKindUseParams,
  PostClientsIdLoyaltyRewardsRewardIdUndoUse200,
  PostClientsIdLoyaltyRewardsRewardIdUndoUse403,
  PostClientsIdLoyaltyRewardsRewardIdUndoUse404,
  PostClientsIdLoyaltyStamps200,
  PostClientsIdLoyaltyStamps403,
  PostClientsIdLoyaltyStamps404,
  PostClientsIdLoyaltyStamps409,
  PostClientsIdLoyaltyStampsStampIdUndo200,
  PostClientsIdLoyaltyStampsStampIdUndo403,
  PostClientsIdLoyaltyStampsStampIdUndo404,
  PostClientsIdLoyaltyStampsStampIdUndo409,
  PostClientsIdMerge200,
  PostClientsIdMergeBody,
  PostClientsIdReferrer200,
  PostClientsIdReferrerBody,
  PostClientsIdReviewRequest200,
  PostClientsIdReviewRequestBody,
  PostClientsIdSplit200,
  PostClientsIdSplitBody,
  PostClientsPosImports201,
  PostClientsPosImportsBatchIdComplete200,
  PostClientsPosImportsBatchIdRows200,
  PostClientsPosImportsBatchIdRows400,
  PostClientsPosImportsBatchIdRows409,
  PostClientsPosImportsBatchIdRowsBody,
  PostClientsPosImportsBatchIdUndo200,
  PostClientsPosImportsBody,
  PostClientsPosImportsPreviewMatch200,
  PostClientsPosImportsPreviewMatchBody,
  PostClientsSearch200,
  PostClientsSearchBody,
} from '.././schemas';

import { customInstance } from '../../axios-instance';

/**
 * Get paginated list of clients with optional search and filters. With `withRowStats=true` each item carries `row`: the visit, booking, cadence, sign-up, last-activity, imported-from (GoHighLevel form, sign-up, old tags) and POS-history facts the Clients table shows (visit fields follow the viewer's calendar; texts and calls in last activity need Inbox access). `importSource` and `ghlTags` narrow to GoHighLevel-imported people, `importBatchId` to the people of one GoHighLevel or POS customer import. `sortBy` = a table column sorts the whole list by that row fact on the server.
 * @summary List clients
 */
export const getClients = (params?: GetClientsParams, signal?: AbortSignal) => {
  return customInstance<GetClients200>({ url: `/clients`, method: 'GET', params, signal });
};

export const getGetClientsInfiniteQueryKey = (params?: GetClientsParams) => {
  return ['infinite', `/clients`, ...(params ? [params] : [])] as const;
};

export const getGetClientsQueryKey = (params?: GetClientsParams) => {
  return [`/clients`, ...(params ? [params] : [])] as const;
};

export const getGetClientsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClients>>>,
  TError = unknown,
>(
  params?: GetClientsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClients>>> = ({ signal }) =>
    getClients(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getClients>>>;
export type GetClientsInfiniteQueryError = unknown;

export function useGetClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClients>>>,
  TError = unknown,
>(
  params: undefined | GetClientsParams,
  options: {
    query: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClients>>,
          TError,
          Awaited<ReturnType<typeof getClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClients>>>,
  TError = unknown,
>(
  params?: GetClientsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClients>>,
          TError,
          Awaited<ReturnType<typeof getClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClients>>>,
  TError = unknown,
>(
  params?: GetClientsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List clients
 */

export function useGetClientsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClients>>>,
  TError = unknown,
>(
  params?: GetClientsParams,
  options?: {
    query?: Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClients>>,
  TError = unknown,
>(
  params?: GetClientsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClients>>> = ({ signal }) =>
    getClients(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsQueryResult = NonNullable<Awaited<ReturnType<typeof getClients>>>;
export type GetClientsQueryError = unknown;

export function useGetClients<TData = Awaited<ReturnType<typeof getClients>>, TError = unknown>(
  params: undefined | GetClientsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClients>>,
          TError,
          Awaited<ReturnType<typeof getClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClients<TData = Awaited<ReturnType<typeof getClients>>, TError = unknown>(
  params?: GetClientsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClients>>,
          TError,
          Awaited<ReturnType<typeof getClients>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClients<TData = Awaited<ReturnType<typeof getClients>>, TError = unknown>(
  params?: GetClientsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List clients
 */

export function useGetClients<TData = Awaited<ReturnType<typeof getClients>>, TError = unknown>(
  params?: GetClientsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClients>>,
  TError = unknown,
>(
  params?: GetClientsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClients>>> = ({ signal }) =>
    getClients(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClients>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getClients>>>;
export type GetClientsSuspenseQueryError = unknown;

export function useGetClientsSuspense<
  TData = Awaited<ReturnType<typeof getClients>>,
  TError = unknown,
>(
  params: undefined | GetClientsParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsSuspense<
  TData = Awaited<ReturnType<typeof getClients>>,
  TError = unknown,
>(
  params?: GetClientsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsSuspense<
  TData = Awaited<ReturnType<typeof getClients>>,
  TError = unknown,
>(
  params?: GetClientsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List clients
 */

export function useGetClientsSuspense<
  TData = Awaited<ReturnType<typeof getClients>>,
  TError = unknown,
>(
  params?: GetClientsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClients>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create a new client
 * @summary Create client
 */
export const postClients = (postClientsBody: PostClientsBody, signal?: AbortSignal) => {
  return customInstance<PostClients201>({
    url: `/clients`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsBody,
    signal,
  });
};

export const getPostClientsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClients>>,
    TError,
    { data: PostClientsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClients>>,
  TError,
  { data: PostClientsBody },
  TContext
> => {
  const mutationKey = ['postClients'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClients>>,
    { data: PostClientsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postClients(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsMutationResult = NonNullable<Awaited<ReturnType<typeof postClients>>>;
export type PostClientsMutationBody = PostClientsBody;
export type PostClientsMutationError = unknown;

/**
 * @summary Create client
 */
export const usePostClients = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClients>>,
      TError,
      { data: PostClientsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClients>>,
  TError,
  { data: PostClientsBody },
  TContext
> => {
  const mutationOptions = getPostClientsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Every client the `GET /clients` filters match, in the order of a Clients table column (`sortBy`), as ids and stages only — what select-all ticks when the table has not loaded every page.
 * @summary List the ids of every client in a list
 */
export const getClientsIds = (params?: GetClientsIdsParams, signal?: AbortSignal) => {
  return customInstance<GetClientsIds200>({ url: `/clients/ids`, method: 'GET', params, signal });
};

export const getGetClientsIdsInfiniteQueryKey = (params?: GetClientsIdsParams) => {
  return ['infinite', `/clients/ids`, ...(params ? [params] : [])] as const;
};

export const getGetClientsIdsQueryKey = (params?: GetClientsIdsParams) => {
  return [`/clients/ids`, ...(params ? [params] : [])] as const;
};

export const getGetClientsIdsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIds>>>,
  TError = unknown,
>(
  params?: GetClientsIdsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdsInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIds>>> = ({ signal }) =>
    getClientsIds(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIds>>
>;
export type GetClientsIdsInfiniteQueryError = unknown;

export function useGetClientsIdsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIds>>>,
  TError = unknown,
>(
  params: undefined | GetClientsIdsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIds>>,
          TError,
          Awaited<ReturnType<typeof getClientsIds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIds>>>,
  TError = unknown,
>(
  params?: GetClientsIdsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIds>>,
          TError,
          Awaited<ReturnType<typeof getClientsIds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIds>>>,
  TError = unknown,
>(
  params?: GetClientsIdsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the ids of every client in a list
 */

export function useGetClientsIdsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIds>>>,
  TError = unknown,
>(
  params?: GetClientsIdsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIds>>,
  TError = unknown,
>(
  params?: GetClientsIdsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIds>>> = ({ signal }) =>
    getClientsIds(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getClientsIds>>>;
export type GetClientsIdsQueryError = unknown;

export function useGetClientsIds<
  TData = Awaited<ReturnType<typeof getClientsIds>>,
  TError = unknown,
>(
  params: undefined | GetClientsIdsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIds>>,
          TError,
          Awaited<ReturnType<typeof getClientsIds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIds<
  TData = Awaited<ReturnType<typeof getClientsIds>>,
  TError = unknown,
>(
  params?: GetClientsIdsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIds>>,
          TError,
          Awaited<ReturnType<typeof getClientsIds>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIds<
  TData = Awaited<ReturnType<typeof getClientsIds>>,
  TError = unknown,
>(
  params?: GetClientsIdsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the ids of every client in a list
 */

export function useGetClientsIds<
  TData = Awaited<ReturnType<typeof getClientsIds>>,
  TError = unknown,
>(
  params?: GetClientsIdsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIds>>,
  TError = unknown,
>(
  params?: GetClientsIdsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIds>>> = ({ signal }) =>
    getClientsIds(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsIds>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIds>>
>;
export type GetClientsIdsSuspenseQueryError = unknown;

export function useGetClientsIdsSuspense<
  TData = Awaited<ReturnType<typeof getClientsIds>>,
  TError = unknown,
>(
  params: undefined | GetClientsIdsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdsSuspense<
  TData = Awaited<ReturnType<typeof getClientsIds>>,
  TError = unknown,
>(
  params?: GetClientsIdsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdsSuspense<
  TData = Awaited<ReturnType<typeof getClientsIds>>,
  TError = unknown,
>(
  params?: GetClientsIdsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the ids of every client in a list
 */

export function useGetClientsIdsSuspense<
  TData = Awaited<ReturnType<typeof getClientsIds>>,
  TError = unknown,
>(
  params?: GetClientsIdsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIds>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdsSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Complex client search with filters (for queries exceeding URL length limits)
 * @summary Search clients
 */
export const postClientsSearch = (
  postClientsSearchBody: PostClientsSearchBody,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsSearch200>({
    url: `/clients/search`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsSearchBody,
    signal,
  });
};

export const getPostClientsSearchMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsSearch>>,
    TError,
    { data: PostClientsSearchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsSearch>>,
  TError,
  { data: PostClientsSearchBody },
  TContext
> => {
  const mutationKey = ['postClientsSearch'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsSearch>>,
    { data: PostClientsSearchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postClientsSearch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsSearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsSearch>>
>;
export type PostClientsSearchMutationBody = PostClientsSearchBody;
export type PostClientsSearchMutationError = unknown;

/**
 * @summary Search clients
 */
export const usePostClientsSearch = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsSearch>>,
      TError,
      { data: PostClientsSearchBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsSearch>>,
  TError,
  { data: PostClientsSearchBody },
  TContext
> => {
  const mutationOptions = getPostClientsSearchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Export clients to CSV file with optional filters (10K row limit). Salon admins and agency members only.
 * @summary Export clients to CSV
 */
export const getClientsExport = (params?: GetClientsExportParams, signal?: AbortSignal) => {
  return customInstance<string>({ url: `/clients/export`, method: 'GET', params, signal });
};

export const getGetClientsExportInfiniteQueryKey = (params?: GetClientsExportParams) => {
  return ['infinite', `/clients/export`, ...(params ? [params] : [])] as const;
};

export const getGetClientsExportQueryKey = (params?: GetClientsExportParams) => {
  return [`/clients/export`, ...(params ? [params] : [])] as const;
};

export const getGetClientsExportInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsExport>>>,
  TError = void,
>(
  params?: GetClientsExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsExportInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsExport>>> = ({ signal }) =>
    getClientsExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsExportInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsExport>>
>;
export type GetClientsExportInfiniteQueryError = void;

export function useGetClientsExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsExport>>>,
  TError = void,
>(
  params: undefined | GetClientsExportParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsExport>>,
          TError,
          Awaited<ReturnType<typeof getClientsExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsExport>>>,
  TError = void,
>(
  params?: GetClientsExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsExport>>,
          TError,
          Awaited<ReturnType<typeof getClientsExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsExport>>>,
  TError = void,
>(
  params?: GetClientsExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export clients to CSV
 */

export function useGetClientsExportInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsExport>>>,
  TError = void,
>(
  params?: GetClientsExportParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsExportInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsExportQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsExport>>,
  TError = void,
>(
  params?: GetClientsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsExport>>> = ({ signal }) =>
    getClientsExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsExportQueryResult = NonNullable<Awaited<ReturnType<typeof getClientsExport>>>;
export type GetClientsExportQueryError = void;

export function useGetClientsExport<
  TData = Awaited<ReturnType<typeof getClientsExport>>,
  TError = void,
>(
  params: undefined | GetClientsExportParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsExport>>,
          TError,
          Awaited<ReturnType<typeof getClientsExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsExport<
  TData = Awaited<ReturnType<typeof getClientsExport>>,
  TError = void,
>(
  params?: GetClientsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsExport>>,
          TError,
          Awaited<ReturnType<typeof getClientsExport>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsExport<
  TData = Awaited<ReturnType<typeof getClientsExport>>,
  TError = void,
>(
  params?: GetClientsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export clients to CSV
 */

export function useGetClientsExport<
  TData = Awaited<ReturnType<typeof getClientsExport>>,
  TError = void,
>(
  params?: GetClientsExportParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsExportQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsExportSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsExport>>,
  TError = void,
>(
  params?: GetClientsExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsExportQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsExport>>> = ({ signal }) =>
    getClientsExport(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsExport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsExportSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsExport>>
>;
export type GetClientsExportSuspenseQueryError = void;

export function useGetClientsExportSuspense<
  TData = Awaited<ReturnType<typeof getClientsExport>>,
  TError = void,
>(
  params: undefined | GetClientsExportParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsExportSuspense<
  TData = Awaited<ReturnType<typeof getClientsExport>>,
  TError = void,
>(
  params?: GetClientsExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsExportSuspense<
  TData = Awaited<ReturnType<typeof getClientsExport>>,
  TError = void,
>(
  params?: GetClientsExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Export clients to CSV
 */

export function useGetClientsExportSuspense<
  TData = Awaited<ReturnType<typeof getClientsExport>>,
  TError = void,
>(
  params?: GetClientsExportParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsExport>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsExportSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * How many active clients each Clients-list Quick filter matches on its own
 * @summary Count clients per Quick filter
 */
export const getClientsQuickFilterCounts = (signal?: AbortSignal) => {
  return customInstance<GetClientsQuickFilterCounts200>({
    url: `/clients/quick-filter-counts`,
    method: 'GET',
    signal,
  });
};

export const getGetClientsQuickFilterCountsInfiniteQueryKey = () => {
  return ['infinite', `/clients/quick-filter-counts`] as const;
};

export const getGetClientsQuickFilterCountsQueryKey = () => {
  return [`/clients/quick-filter-counts`] as const;
};

export const getGetClientsQuickFilterCountsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsQuickFilterCountsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>> = ({
    signal,
  }) => getClientsQuickFilterCounts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsQuickFilterCountsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsQuickFilterCounts>>
>;
export type GetClientsQuickFilterCountsInfiniteQueryError = unknown;

export function useGetClientsQuickFilterCountsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
          TError,
          Awaited<ReturnType<typeof getClientsQuickFilterCounts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsQuickFilterCountsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
          TError,
          Awaited<ReturnType<typeof getClientsQuickFilterCounts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsQuickFilterCountsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count clients per Quick filter
 */

export function useGetClientsQuickFilterCountsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsQuickFilterCountsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsQuickFilterCountsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsQuickFilterCountsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>> = ({
    signal,
  }) => getClientsQuickFilterCounts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsQuickFilterCountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsQuickFilterCounts>>
>;
export type GetClientsQuickFilterCountsQueryError = unknown;

export function useGetClientsQuickFilterCounts<
  TData = Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
          TError,
          Awaited<ReturnType<typeof getClientsQuickFilterCounts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsQuickFilterCounts<
  TData = Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
          TError,
          Awaited<ReturnType<typeof getClientsQuickFilterCounts>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsQuickFilterCounts<
  TData = Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count clients per Quick filter
 */

export function useGetClientsQuickFilterCounts<
  TData = Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsQuickFilterCountsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsQuickFilterCountsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsQuickFilterCountsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsQuickFilterCounts>>> = ({
    signal,
  }) => getClientsQuickFilterCounts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsQuickFilterCountsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsQuickFilterCounts>>
>;
export type GetClientsQuickFilterCountsSuspenseQueryError = unknown;

export function useGetClientsQuickFilterCountsSuspense<
  TData = Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsQuickFilterCountsSuspense<
  TData = Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsQuickFilterCountsSuspense<
  TData = Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count clients per Quick filter
 */

export function useGetClientsQuickFilterCountsSuspense<
  TData = Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsQuickFilterCounts>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsQuickFilterCountsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Bounded name search returning IDs and permitted name fields only. Does not grant client profile access.
 * @summary Find clients for an authorized booking or checkout
 */
export const getClientsPicker = (params: GetClientsPickerParams, signal?: AbortSignal) => {
  return customInstance<GetClientsPicker200>({
    url: `/clients/picker`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetClientsPickerInfiniteQueryKey = (params?: GetClientsPickerParams) => {
  return ['infinite', `/clients/picker`, ...(params ? [params] : [])] as const;
};

export const getGetClientsPickerQueryKey = (params?: GetClientsPickerParams) => {
  return [`/clients/picker`, ...(params ? [params] : [])] as const;
};

export const getGetClientsPickerInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPicker>>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsPickerInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsPicker>>> = ({ signal }) =>
    getClientsPicker(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsPicker>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsPickerInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsPicker>>
>;
export type GetClientsPickerInfiniteQueryError = void;

export function useGetClientsPickerInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPicker>>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsPicker>>,
          TError,
          Awaited<ReturnType<typeof getClientsPicker>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPickerInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPicker>>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsPicker>>,
          TError,
          Awaited<ReturnType<typeof getClientsPicker>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPickerInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPicker>>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find clients for an authorized booking or checkout
 */

export function useGetClientsPickerInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPicker>>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsPickerInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsPickerQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsPicker>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsPickerQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsPicker>>> = ({ signal }) =>
    getClientsPicker(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsPicker>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsPickerQueryResult = NonNullable<Awaited<ReturnType<typeof getClientsPicker>>>;
export type GetClientsPickerQueryError = void;

export function useGetClientsPicker<
  TData = Awaited<ReturnType<typeof getClientsPicker>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsPicker>>,
          TError,
          Awaited<ReturnType<typeof getClientsPicker>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPicker<
  TData = Awaited<ReturnType<typeof getClientsPicker>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsPicker>>,
          TError,
          Awaited<ReturnType<typeof getClientsPicker>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPicker<
  TData = Awaited<ReturnType<typeof getClientsPicker>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find clients for an authorized booking or checkout
 */

export function useGetClientsPicker<
  TData = Awaited<ReturnType<typeof getClientsPicker>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsPickerQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsPickerSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsPicker>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsPickerQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsPicker>>> = ({ signal }) =>
    getClientsPicker(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsPicker>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsPickerSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsPicker>>
>;
export type GetClientsPickerSuspenseQueryError = void;

export function useGetClientsPickerSuspense<
  TData = Awaited<ReturnType<typeof getClientsPicker>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPickerSuspense<
  TData = Awaited<ReturnType<typeof getClientsPicker>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPickerSuspense<
  TData = Awaited<ReturnType<typeof getClientsPicker>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Find clients for an authorized booking or checkout
 */

export function useGetClientsPickerSuspense<
  TData = Awaited<ReturnType<typeof getClientsPicker>>,
  TError = void,
>(
  params: GetClientsPickerParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPicker>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsPickerSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Who already owns a phone (phone-only client identity), for the staff warning before saving a client. Placeholder numbers (salon numbers, 000…, 1234567890) return an empty list. Returns first name + last-name initial only. Requires client create access plus contact-details access.
 * @summary Profiles already on a phone number
 */
export const getClientsPhoneProfiles = (
  params: GetClientsPhoneProfilesParams,
  signal?: AbortSignal
) => {
  return customInstance<GetClientsPhoneProfiles200>({
    url: `/clients/phone-profiles`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetClientsPhoneProfilesInfiniteQueryKey = (
  params?: GetClientsPhoneProfilesParams
) => {
  return ['infinite', `/clients/phone-profiles`, ...(params ? [params] : [])] as const;
};

export const getGetClientsPhoneProfilesQueryKey = (params?: GetClientsPhoneProfilesParams) => {
  return [`/clients/phone-profiles`, ...(params ? [params] : [])] as const;
};

export const getGetClientsPhoneProfilesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPhoneProfiles>>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsPhoneProfilesInfiniteQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsPhoneProfiles>>> = ({
    signal,
  }) => getClientsPhoneProfiles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsPhoneProfilesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsPhoneProfiles>>
>;
export type GetClientsPhoneProfilesInfiniteQueryError = void;

export function useGetClientsPhoneProfilesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPhoneProfiles>>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
          TError,
          Awaited<ReturnType<typeof getClientsPhoneProfiles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPhoneProfilesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPhoneProfiles>>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
          TError,
          Awaited<ReturnType<typeof getClientsPhoneProfiles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPhoneProfilesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPhoneProfiles>>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Profiles already on a phone number
 */

export function useGetClientsPhoneProfilesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPhoneProfiles>>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsPhoneProfilesInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsPhoneProfilesQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsPhoneProfilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsPhoneProfiles>>> = ({
    signal,
  }) => getClientsPhoneProfiles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsPhoneProfilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsPhoneProfiles>>
>;
export type GetClientsPhoneProfilesQueryError = void;

export function useGetClientsPhoneProfiles<
  TData = Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
          TError,
          Awaited<ReturnType<typeof getClientsPhoneProfiles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPhoneProfiles<
  TData = Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
          TError,
          Awaited<ReturnType<typeof getClientsPhoneProfiles>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPhoneProfiles<
  TData = Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Profiles already on a phone number
 */

export function useGetClientsPhoneProfiles<
  TData = Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsPhoneProfilesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsPhoneProfilesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsPhoneProfilesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsPhoneProfiles>>> = ({
    signal,
  }) => getClientsPhoneProfiles(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsPhoneProfilesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsPhoneProfiles>>
>;
export type GetClientsPhoneProfilesSuspenseQueryError = void;

export function useGetClientsPhoneProfilesSuspense<
  TData = Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPhoneProfilesSuspense<
  TData = Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPhoneProfilesSuspense<
  TData = Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Profiles already on a phone number
 */

export function useGetClientsPhoneProfilesSuspense<
  TData = Awaited<ReturnType<typeof getClientsPhoneProfiles>>,
  TError = void,
>(
  params: GetClientsPhoneProfilesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPhoneProfiles>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsPhoneProfilesSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Review step: how many of the file’s phones already belong to a Hayven client (read-only)
 */
export const postClientsGohighlevelImportsPreviewMatch = (
  postClientsGohighlevelImportsPreviewMatchBody: PostClientsGohighlevelImportsPreviewMatchBody,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsGohighlevelImportsPreviewMatch200>({
    url: `/clients/gohighlevel-imports/preview-match`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsGohighlevelImportsPreviewMatchBody,
    signal,
  });
};

export const getPostClientsGohighlevelImportsPreviewMatchMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsGohighlevelImportsPreviewMatch>>,
    TError,
    { data: PostClientsGohighlevelImportsPreviewMatchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsPreviewMatch>>,
  TError,
  { data: PostClientsGohighlevelImportsPreviewMatchBody },
  TContext
> => {
  const mutationKey = ['postClientsGohighlevelImportsPreviewMatch'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsGohighlevelImportsPreviewMatch>>,
    { data: PostClientsGohighlevelImportsPreviewMatchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postClientsGohighlevelImportsPreviewMatch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsGohighlevelImportsPreviewMatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsPreviewMatch>>
>;
export type PostClientsGohighlevelImportsPreviewMatchMutationBody =
  PostClientsGohighlevelImportsPreviewMatchBody;
export type PostClientsGohighlevelImportsPreviewMatchMutationError = void;

/**
 * @summary Review step: how many of the file’s phones already belong to a Hayven client (read-only)
 */
export const usePostClientsGohighlevelImportsPreviewMatch = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsGohighlevelImportsPreviewMatch>>,
      TError,
      { data: PostClientsGohighlevelImportsPreviewMatchBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsPreviewMatch>>,
  TError,
  { data: PostClientsGohighlevelImportsPreviewMatchBody },
  TContext
> => {
  const mutationOptions = getPostClientsGohighlevelImportsPreviewMatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Import history: the salon’s GoHighLevel imports, newest first (latest 50)
 */
export const getClientsGohighlevelImports = (signal?: AbortSignal) => {
  return customInstance<GetClientsGohighlevelImports200>({
    url: `/clients/gohighlevel-imports`,
    method: 'GET',
    signal,
  });
};

export const getGetClientsGohighlevelImportsInfiniteQueryKey = () => {
  return ['infinite', `/clients/gohighlevel-imports`] as const;
};

export const getGetClientsGohighlevelImportsQueryKey = () => {
  return [`/clients/gohighlevel-imports`] as const;
};

export const getGetClientsGohighlevelImportsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsGohighlevelImports>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelImports>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsGohighlevelImportsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsGohighlevelImports>>> = ({
    signal,
  }) => getClientsGohighlevelImports(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsGohighlevelImportsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsGohighlevelImports>>
>;
export type GetClientsGohighlevelImportsInfiniteQueryError = void;

export function useGetClientsGohighlevelImportsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsGohighlevelImports>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
          TError,
          Awaited<ReturnType<typeof getClientsGohighlevelImports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsGohighlevelImportsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsGohighlevelImports>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
          TError,
          Awaited<ReturnType<typeof getClientsGohighlevelImports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsGohighlevelImportsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsGohighlevelImports>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Import history: the salon’s GoHighLevel imports, newest first (latest 50)
 */

export function useGetClientsGohighlevelImportsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsGohighlevelImports>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsGohighlevelImportsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsGohighlevelImportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelImports>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsGohighlevelImportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsGohighlevelImports>>> = ({
    signal,
  }) => getClientsGohighlevelImports(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsGohighlevelImportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsGohighlevelImports>>
>;
export type GetClientsGohighlevelImportsQueryError = void;

export function useGetClientsGohighlevelImports<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelImports>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
          TError,
          Awaited<ReturnType<typeof getClientsGohighlevelImports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsGohighlevelImports<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelImports>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
          TError,
          Awaited<ReturnType<typeof getClientsGohighlevelImports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsGohighlevelImports<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Import history: the salon’s GoHighLevel imports, newest first (latest 50)
 */

export function useGetClientsGohighlevelImports<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsGohighlevelImportsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsGohighlevelImportsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelImports>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsGohighlevelImportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsGohighlevelImports>>> = ({
    signal,
  }) => getClientsGohighlevelImports(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsGohighlevelImportsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsGohighlevelImports>>
>;
export type GetClientsGohighlevelImportsSuspenseQueryError = void;

export function useGetClientsGohighlevelImportsSuspense<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsGohighlevelImportsSuspense<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsGohighlevelImportsSuspense<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Import history: the salon’s GoHighLevel imports, newest first (latest 50)
 */

export function useGetClientsGohighlevelImportsSuspense<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsGohighlevelImports>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsGohighlevelImportsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Start a GoHighLevel import (one per file) with the owner’s text-consent attestation
 */
export const postClientsGohighlevelImports = (
  postClientsGohighlevelImportsBody: PostClientsGohighlevelImportsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsGohighlevelImports201>({
    url: `/clients/gohighlevel-imports`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsGohighlevelImportsBody,
    signal,
  });
};

export const getPostClientsGohighlevelImportsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsGohighlevelImports>>,
    TError,
    { data: PostClientsGohighlevelImportsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsGohighlevelImports>>,
  TError,
  { data: PostClientsGohighlevelImportsBody },
  TContext
> => {
  const mutationKey = ['postClientsGohighlevelImports'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsGohighlevelImports>>,
    { data: PostClientsGohighlevelImportsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postClientsGohighlevelImports(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsGohighlevelImportsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsGohighlevelImports>>
>;
export type PostClientsGohighlevelImportsMutationBody = PostClientsGohighlevelImportsBody;
export type PostClientsGohighlevelImportsMutationError = void;

/**
 * @summary Start a GoHighLevel import (one per file) with the owner’s text-consent attestation
 */
export const usePostClientsGohighlevelImports = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsGohighlevelImports>>,
      TError,
      { data: PostClientsGohighlevelImportsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsGohighlevelImports>>,
  TError,
  { data: PostClientsGohighlevelImportsBody },
  TContext
> => {
  const mutationOptions = getPostClientsGohighlevelImportsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Keep GoHighLevel’s opted-out (DND) phones opted out: records a marketing opt-out for each phone with no marketing choice in Hayven yet. Call before the rows, in both list modes. Idempotent.
 */
export const postClientsGohighlevelImportsBatchIdDoNotDisturb = (
  batchId: string,
  postClientsGohighlevelImportsBatchIdDoNotDisturbBody: PostClientsGohighlevelImportsBatchIdDoNotDisturbBody,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsGohighlevelImportsBatchIdDoNotDisturb200>({
    url: `/clients/gohighlevel-imports/${batchId}/do-not-disturb`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsGohighlevelImportsBatchIdDoNotDisturbBody,
    signal,
  });
};

export const getPostClientsGohighlevelImportsBatchIdDoNotDisturbMutationOptions = <
  TError = void | PostClientsGohighlevelImportsBatchIdDoNotDisturb409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdDoNotDisturb>>,
    TError,
    { batchId: string; data: PostClientsGohighlevelImportsBatchIdDoNotDisturbBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdDoNotDisturb>>,
  TError,
  { batchId: string; data: PostClientsGohighlevelImportsBatchIdDoNotDisturbBody },
  TContext
> => {
  const mutationKey = ['postClientsGohighlevelImportsBatchIdDoNotDisturb'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdDoNotDisturb>>,
    { batchId: string; data: PostClientsGohighlevelImportsBatchIdDoNotDisturbBody }
  > = (props) => {
    const { batchId, data } = props ?? {};

    return postClientsGohighlevelImportsBatchIdDoNotDisturb(batchId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsGohighlevelImportsBatchIdDoNotDisturbMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdDoNotDisturb>>
>;
export type PostClientsGohighlevelImportsBatchIdDoNotDisturbMutationBody =
  PostClientsGohighlevelImportsBatchIdDoNotDisturbBody;
export type PostClientsGohighlevelImportsBatchIdDoNotDisturbMutationError =
  void | PostClientsGohighlevelImportsBatchIdDoNotDisturb409;

/**
 * @summary Keep GoHighLevel’s opted-out (DND) phones opted out: records a marketing opt-out for each phone with no marketing choice in Hayven yet. Call before the rows, in both list modes. Idempotent.
 */
export const usePostClientsGohighlevelImportsBatchIdDoNotDisturb = <
  TError = void | PostClientsGohighlevelImportsBatchIdDoNotDisturb409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdDoNotDisturb>>,
      TError,
      { batchId: string; data: PostClientsGohighlevelImportsBatchIdDoNotDisturbBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdDoNotDisturb>>,
  TError,
  { batchId: string; data: PostClientsGohighlevelImportsBatchIdDoNotDisturbBody },
  TContext
> => {
  const mutationOptions =
    getPostClientsGohighlevelImportsBatchIdDoNotDisturbMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload up to 1,000 form sign-ups starting at `offset`. New phones become Leads dated at their GHL sign-up; a phone already in Hayven only gets its blank name / email filled. Consent is granted only to phones with no marketing choice in Hayven; a phone that opted out is never re-granted (nor created). Rows already received are acknowledged without being written again. Refused until the opted-out (DND) list was sent.
 */
export const postClientsGohighlevelImportsBatchIdRows = (
  batchId: string,
  postClientsGohighlevelImportsBatchIdRowsBody: PostClientsGohighlevelImportsBatchIdRowsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsGohighlevelImportsBatchIdRows200>({
    url: `/clients/gohighlevel-imports/${batchId}/rows`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsGohighlevelImportsBatchIdRowsBody,
    signal,
  });
};

export const getPostClientsGohighlevelImportsBatchIdRowsMutationOptions = <
  TError =
    | PostClientsGohighlevelImportsBatchIdRows400
    | void
    | PostClientsGohighlevelImportsBatchIdRows409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdRows>>,
    TError,
    { batchId: string; data: PostClientsGohighlevelImportsBatchIdRowsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdRows>>,
  TError,
  { batchId: string; data: PostClientsGohighlevelImportsBatchIdRowsBody },
  TContext
> => {
  const mutationKey = ['postClientsGohighlevelImportsBatchIdRows'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdRows>>,
    { batchId: string; data: PostClientsGohighlevelImportsBatchIdRowsBody }
  > = (props) => {
    const { batchId, data } = props ?? {};

    return postClientsGohighlevelImportsBatchIdRows(batchId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsGohighlevelImportsBatchIdRowsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdRows>>
>;
export type PostClientsGohighlevelImportsBatchIdRowsMutationBody =
  PostClientsGohighlevelImportsBatchIdRowsBody;
export type PostClientsGohighlevelImportsBatchIdRowsMutationError =
  | PostClientsGohighlevelImportsBatchIdRows400
  | void
  | PostClientsGohighlevelImportsBatchIdRows409;

/**
 * @summary Upload up to 1,000 form sign-ups starting at `offset`. New phones become Leads dated at their GHL sign-up; a phone already in Hayven only gets its blank name / email filled. Consent is granted only to phones with no marketing choice in Hayven; a phone that opted out is never re-granted (nor created). Rows already received are acknowledged without being written again. Refused until the opted-out (DND) list was sent.
 */
export const usePostClientsGohighlevelImportsBatchIdRows = <
  TError =
    | PostClientsGohighlevelImportsBatchIdRows400
    | void
    | PostClientsGohighlevelImportsBatchIdRows409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdRows>>,
      TError,
      { batchId: string; data: PostClientsGohighlevelImportsBatchIdRowsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdRows>>,
  TError,
  { batchId: string; data: PostClientsGohighlevelImportsBatchIdRowsBody },
  TContext
> => {
  const mutationOptions = getPostClientsGohighlevelImportsBatchIdRowsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Finish a GoHighLevel import (idempotent); returns what the whole import wrote
 */
export const postClientsGohighlevelImportsBatchIdComplete = (
  batchId: string,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsGohighlevelImportsBatchIdComplete200>({
    url: `/clients/gohighlevel-imports/${batchId}/complete`,
    method: 'POST',
    signal,
  });
};

export const getPostClientsGohighlevelImportsBatchIdCompleteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdComplete>>,
    TError,
    { batchId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdComplete>>,
  TError,
  { batchId: string },
  TContext
> => {
  const mutationKey = ['postClientsGohighlevelImportsBatchIdComplete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdComplete>>,
    { batchId: string }
  > = (props) => {
    const { batchId } = props ?? {};

    return postClientsGohighlevelImportsBatchIdComplete(batchId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsGohighlevelImportsBatchIdCompleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdComplete>>
>;

export type PostClientsGohighlevelImportsBatchIdCompleteMutationError = void;

/**
 * @summary Finish a GoHighLevel import (idempotent); returns what the whole import wrote
 */
export const usePostClientsGohighlevelImportsBatchIdComplete = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdComplete>>,
      TError,
      { batchId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdComplete>>,
  TError,
  { batchId: string },
  TContext
> => {
  const mutationOptions = getPostClientsGohighlevelImportsBatchIdCompleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Undo an import (finished or abandoned midway; it then takes no more rows): removes the Leads it created that have had no activity since (no booking, message, text, edit, sign-up or later import); everyone else is kept. Clients it only matched are untouched and every opt-out stays. Idempotent — a repeat returns the first undo’s counts.
 */
export const postClientsGohighlevelImportsBatchIdUndo = (batchId: string, signal?: AbortSignal) => {
  return customInstance<PostClientsGohighlevelImportsBatchIdUndo200>({
    url: `/clients/gohighlevel-imports/${batchId}/undo`,
    method: 'POST',
    signal,
  });
};

export const getPostClientsGohighlevelImportsBatchIdUndoMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdUndo>>,
    TError,
    { batchId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdUndo>>,
  TError,
  { batchId: string },
  TContext
> => {
  const mutationKey = ['postClientsGohighlevelImportsBatchIdUndo'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdUndo>>,
    { batchId: string }
  > = (props) => {
    const { batchId } = props ?? {};

    return postClientsGohighlevelImportsBatchIdUndo(batchId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsGohighlevelImportsBatchIdUndoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdUndo>>
>;

export type PostClientsGohighlevelImportsBatchIdUndoMutationError = void;

/**
 * @summary Undo an import (finished or abandoned midway; it then takes no more rows): removes the Leads it created that have had no activity since (no booking, message, text, edit, sign-up or later import); everyone else is kept. Clients it only matched are untouched and every opt-out stays. Idempotent — a repeat returns the first undo’s counts.
 */
export const usePostClientsGohighlevelImportsBatchIdUndo = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdUndo>>,
      TError,
      { batchId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsGohighlevelImportsBatchIdUndo>>,
  TError,
  { batchId: string },
  TContext
> => {
  const mutationOptions = getPostClientsGohighlevelImportsBatchIdUndoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Review step: how many of the file’s phones already belong to a Hayven client (read-only)
 */
export const postClientsPosImportsPreviewMatch = (
  postClientsPosImportsPreviewMatchBody: PostClientsPosImportsPreviewMatchBody,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsPosImportsPreviewMatch200>({
    url: `/clients/pos-imports/preview-match`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsPosImportsPreviewMatchBody,
    signal,
  });
};

export const getPostClientsPosImportsPreviewMatchMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsPosImportsPreviewMatch>>,
    TError,
    { data: PostClientsPosImportsPreviewMatchBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsPosImportsPreviewMatch>>,
  TError,
  { data: PostClientsPosImportsPreviewMatchBody },
  TContext
> => {
  const mutationKey = ['postClientsPosImportsPreviewMatch'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsPosImportsPreviewMatch>>,
    { data: PostClientsPosImportsPreviewMatchBody }
  > = (props) => {
    const { data } = props ?? {};

    return postClientsPosImportsPreviewMatch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsPosImportsPreviewMatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsPosImportsPreviewMatch>>
>;
export type PostClientsPosImportsPreviewMatchMutationBody = PostClientsPosImportsPreviewMatchBody;
export type PostClientsPosImportsPreviewMatchMutationError = void;

/**
 * @summary Review step: how many of the file’s phones already belong to a Hayven client (read-only)
 */
export const usePostClientsPosImportsPreviewMatch = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsPosImportsPreviewMatch>>,
      TError,
      { data: PostClientsPosImportsPreviewMatchBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsPosImportsPreviewMatch>>,
  TError,
  { data: PostClientsPosImportsPreviewMatchBody },
  TContext
> => {
  const mutationOptions = getPostClientsPosImportsPreviewMatchMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Import history: the salon’s POS imports, newest first (latest 50)
 */
export const getClientsPosImports = (signal?: AbortSignal) => {
  return customInstance<GetClientsPosImports200>({
    url: `/clients/pos-imports`,
    method: 'GET',
    signal,
  });
};

export const getGetClientsPosImportsInfiniteQueryKey = () => {
  return ['infinite', `/clients/pos-imports`] as const;
};

export const getGetClientsPosImportsQueryKey = () => {
  return [`/clients/pos-imports`] as const;
};

export const getGetClientsPosImportsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPosImports>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsPosImportsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsPosImports>>> = ({ signal }) =>
    getClientsPosImports(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsPosImports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsPosImportsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsPosImports>>
>;
export type GetClientsPosImportsInfiniteQueryError = void;

export function useGetClientsPosImportsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPosImports>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsPosImports>>,
          TError,
          Awaited<ReturnType<typeof getClientsPosImports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPosImportsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPosImports>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsPosImports>>,
          TError,
          Awaited<ReturnType<typeof getClientsPosImports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPosImportsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPosImports>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Import history: the salon’s POS imports, newest first (latest 50)
 */

export function useGetClientsPosImportsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsPosImports>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsPosImportsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsPosImportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsPosImports>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsPosImportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsPosImports>>> = ({ signal }) =>
    getClientsPosImports(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsPosImports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsPosImportsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsPosImports>>
>;
export type GetClientsPosImportsQueryError = void;

export function useGetClientsPosImports<
  TData = Awaited<ReturnType<typeof getClientsPosImports>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsPosImports>>,
          TError,
          Awaited<ReturnType<typeof getClientsPosImports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPosImports<
  TData = Awaited<ReturnType<typeof getClientsPosImports>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsPosImports>>,
          TError,
          Awaited<ReturnType<typeof getClientsPosImports>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPosImports<
  TData = Awaited<ReturnType<typeof getClientsPosImports>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Import history: the salon’s POS imports, newest first (latest 50)
 */

export function useGetClientsPosImports<
  TData = Awaited<ReturnType<typeof getClientsPosImports>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsPosImportsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsPosImportsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsPosImports>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsPosImportsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsPosImports>>> = ({ signal }) =>
    getClientsPosImports(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsPosImports>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsPosImportsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsPosImports>>
>;
export type GetClientsPosImportsSuspenseQueryError = void;

export function useGetClientsPosImportsSuspense<
  TData = Awaited<ReturnType<typeof getClientsPosImports>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPosImportsSuspense<
  TData = Awaited<ReturnType<typeof getClientsPosImports>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsPosImportsSuspense<
  TData = Awaited<ReturnType<typeof getClientsPosImports>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Import history: the salon’s POS imports, newest first (latest 50)
 */

export function useGetClientsPosImportsSuspense<
  TData = Awaited<ReturnType<typeof getClientsPosImports>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsPosImports>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsPosImportsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Start a POS customer import (one per upload; several files of one POS are merged in the browser)
 */
export const postClientsPosImports = (
  postClientsPosImportsBody: PostClientsPosImportsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsPosImports201>({
    url: `/clients/pos-imports`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsPosImportsBody,
    signal,
  });
};

export const getPostClientsPosImportsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsPosImports>>,
    TError,
    { data: PostClientsPosImportsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsPosImports>>,
  TError,
  { data: PostClientsPosImportsBody },
  TContext
> => {
  const mutationKey = ['postClientsPosImports'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsPosImports>>,
    { data: PostClientsPosImportsBody }
  > = (props) => {
    const { data } = props ?? {};

    return postClientsPosImports(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsPosImportsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsPosImports>>
>;
export type PostClientsPosImportsMutationBody = PostClientsPosImportsBody;
export type PostClientsPosImportsMutationError = void;

/**
 * @summary Start a POS customer import (one per upload; several files of one POS are merged in the browser)
 */
export const usePostClientsPosImports = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsPosImports>>,
      TError,
      { data: PostClientsPosImportsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsPosImports>>,
  TError,
  { data: PostClientsPosImportsBody },
  TContext
> => {
  const mutationOptions = getPostClientsPosImportsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload up to 1,000 POS customers starting at `offset`. Every phone is marked as a known past client; a new phone with a usable name becomes an Active client (no marketing consent); a phone already in Hayven only gets its blank name / notes / Heads-up filled. Rows already received are acknowledged without being written again.
 */
export const postClientsPosImportsBatchIdRows = (
  batchId: string,
  postClientsPosImportsBatchIdRowsBody: PostClientsPosImportsBatchIdRowsBody,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsPosImportsBatchIdRows200>({
    url: `/clients/pos-imports/${batchId}/rows`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsPosImportsBatchIdRowsBody,
    signal,
  });
};

export const getPostClientsPosImportsBatchIdRowsMutationOptions = <
  TError = PostClientsPosImportsBatchIdRows400 | void | PostClientsPosImportsBatchIdRows409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsPosImportsBatchIdRows>>,
    TError,
    { batchId: string; data: PostClientsPosImportsBatchIdRowsBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsPosImportsBatchIdRows>>,
  TError,
  { batchId: string; data: PostClientsPosImportsBatchIdRowsBody },
  TContext
> => {
  const mutationKey = ['postClientsPosImportsBatchIdRows'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsPosImportsBatchIdRows>>,
    { batchId: string; data: PostClientsPosImportsBatchIdRowsBody }
  > = (props) => {
    const { batchId, data } = props ?? {};

    return postClientsPosImportsBatchIdRows(batchId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsPosImportsBatchIdRowsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsPosImportsBatchIdRows>>
>;
export type PostClientsPosImportsBatchIdRowsMutationBody = PostClientsPosImportsBatchIdRowsBody;
export type PostClientsPosImportsBatchIdRowsMutationError =
  | PostClientsPosImportsBatchIdRows400
  | void
  | PostClientsPosImportsBatchIdRows409;

/**
 * @summary Upload up to 1,000 POS customers starting at `offset`. Every phone is marked as a known past client; a new phone with a usable name becomes an Active client (no marketing consent); a phone already in Hayven only gets its blank name / notes / Heads-up filled. Rows already received are acknowledged without being written again.
 */
export const usePostClientsPosImportsBatchIdRows = <
  TError = PostClientsPosImportsBatchIdRows400 | void | PostClientsPosImportsBatchIdRows409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsPosImportsBatchIdRows>>,
      TError,
      { batchId: string; data: PostClientsPosImportsBatchIdRowsBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsPosImportsBatchIdRows>>,
  TError,
  { batchId: string; data: PostClientsPosImportsBatchIdRowsBody },
  TContext
> => {
  const mutationOptions = getPostClientsPosImportsBatchIdRowsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Finish a POS import (idempotent); returns what the whole import wrote
 */
export const postClientsPosImportsBatchIdComplete = (batchId: string, signal?: AbortSignal) => {
  return customInstance<PostClientsPosImportsBatchIdComplete200>({
    url: `/clients/pos-imports/${batchId}/complete`,
    method: 'POST',
    signal,
  });
};

export const getPostClientsPosImportsBatchIdCompleteMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsPosImportsBatchIdComplete>>,
    TError,
    { batchId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsPosImportsBatchIdComplete>>,
  TError,
  { batchId: string },
  TContext
> => {
  const mutationKey = ['postClientsPosImportsBatchIdComplete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsPosImportsBatchIdComplete>>,
    { batchId: string }
  > = (props) => {
    const { batchId } = props ?? {};

    return postClientsPosImportsBatchIdComplete(batchId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsPosImportsBatchIdCompleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsPosImportsBatchIdComplete>>
>;

export type PostClientsPosImportsBatchIdCompleteMutationError = void;

/**
 * @summary Finish a POS import (idempotent); returns what the whole import wrote
 */
export const usePostClientsPosImportsBatchIdComplete = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsPosImportsBatchIdComplete>>,
      TError,
      { batchId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsPosImportsBatchIdComplete>>,
  TError,
  { batchId: string },
  TContext
> => {
  const mutationOptions = getPostClientsPosImportsBatchIdCompleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Undo a POS import (finished or abandoned midway; it then takes no more rows): removes the clients it created that have had no activity since (no booking, message, text, edit, sign-up or later import); everyone else is kept. Its known-past-client marks are handed to another live POS import of the salon, else removed. Clients it only matched are untouched. Idempotent — a repeat returns the first undo’s counts.
 */
export const postClientsPosImportsBatchIdUndo = (batchId: string, signal?: AbortSignal) => {
  return customInstance<PostClientsPosImportsBatchIdUndo200>({
    url: `/clients/pos-imports/${batchId}/undo`,
    method: 'POST',
    signal,
  });
};

export const getPostClientsPosImportsBatchIdUndoMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsPosImportsBatchIdUndo>>,
    TError,
    { batchId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsPosImportsBatchIdUndo>>,
  TError,
  { batchId: string },
  TContext
> => {
  const mutationKey = ['postClientsPosImportsBatchIdUndo'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsPosImportsBatchIdUndo>>,
    { batchId: string }
  > = (props) => {
    const { batchId } = props ?? {};

    return postClientsPosImportsBatchIdUndo(batchId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsPosImportsBatchIdUndoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsPosImportsBatchIdUndo>>
>;

export type PostClientsPosImportsBatchIdUndoMutationError = void;

/**
 * @summary Undo a POS import (finished or abandoned midway; it then takes no more rows): removes the clients it created that have had no activity since (no booking, message, text, edit, sign-up or later import); everyone else is kept. Its known-past-client marks are handed to another live POS import of the salon, else removed. Clients it only matched are untouched. Idempotent — a repeat returns the first undo’s counts.
 */
export const usePostClientsPosImportsBatchIdUndo = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsPosImportsBatchIdUndo>>,
      TError,
      { batchId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsPosImportsBatchIdUndo>>,
  TError,
  { batchId: string },
  TContext
> => {
  const mutationOptions = getPostClientsPosImportsBatchIdUndoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Old GoHighLevel tags carried by imported people (read-only labels for the Clients filter), with how many live people carry each, most used first, plus how many live people were imported at all (0 = the salon never imported from GoHighLevel: show no GoHighLevel filter).
 * @summary List GoHighLevel tags
 */
export const getClientsGohighlevelTags = (signal?: AbortSignal) => {
  return customInstance<GetClientsGohighlevelTags200>({
    url: `/clients/gohighlevel-tags`,
    method: 'GET',
    signal,
  });
};

export const getGetClientsGohighlevelTagsInfiniteQueryKey = () => {
  return ['infinite', `/clients/gohighlevel-tags`] as const;
};

export const getGetClientsGohighlevelTagsQueryKey = () => {
  return [`/clients/gohighlevel-tags`] as const;
};

export const getGetClientsGohighlevelTagsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsGohighlevelTags>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsGohighlevelTagsInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsGohighlevelTags>>> = ({
    signal,
  }) => getClientsGohighlevelTags(signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsGohighlevelTagsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsGohighlevelTags>>
>;
export type GetClientsGohighlevelTagsInfiniteQueryError = unknown;

export function useGetClientsGohighlevelTagsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsGohighlevelTags>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
          TError,
          Awaited<ReturnType<typeof getClientsGohighlevelTags>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsGohighlevelTagsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsGohighlevelTags>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
          TError,
          Awaited<ReturnType<typeof getClientsGohighlevelTags>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsGohighlevelTagsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsGohighlevelTags>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List GoHighLevel tags
 */

export function useGetClientsGohighlevelTagsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsGohighlevelTags>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsGohighlevelTagsInfiniteQueryOptions(options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsGohighlevelTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsGohighlevelTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsGohighlevelTags>>> = ({
    signal,
  }) => getClientsGohighlevelTags(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsGohighlevelTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsGohighlevelTags>>
>;
export type GetClientsGohighlevelTagsQueryError = unknown;

export function useGetClientsGohighlevelTags<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
          TError,
          Awaited<ReturnType<typeof getClientsGohighlevelTags>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsGohighlevelTags<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
          TError,
          Awaited<ReturnType<typeof getClientsGohighlevelTags>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsGohighlevelTags<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List GoHighLevel tags
 */

export function useGetClientsGohighlevelTags<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsGohighlevelTagsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsGohighlevelTagsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsGohighlevelTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsGohighlevelTags>>> = ({
    signal,
  }) => getClientsGohighlevelTags(signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsGohighlevelTagsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsGohighlevelTags>>
>;
export type GetClientsGohighlevelTagsSuspenseQueryError = unknown;

export function useGetClientsGohighlevelTagsSuspense<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsGohighlevelTagsSuspense<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsGohighlevelTagsSuspense<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List GoHighLevel tags
 */

export function useGetClientsGohighlevelTagsSuspense<
  TData = Awaited<ReturnType<typeof getClientsGohighlevelTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsGohighlevelTags>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsGohighlevelTagsSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get a single client by ID with optional relations
 * @summary Get client
 */
export const getClientsId = (id: string, params?: GetClientsIdParams, signal?: AbortSignal) => {
  return customInstance<GetClientsId200>({ url: `/clients/${id}`, method: 'GET', params, signal });
};

export const getGetClientsIdInfiniteQueryKey = (id?: string, params?: GetClientsIdParams) => {
  return ['infinite', `/clients/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetClientsIdQueryKey = (id?: string, params?: GetClientsIdParams) => {
  return [`/clients/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetClientsIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsId>>>,
  TError = unknown,
>(
  id: string,
  params?: GetClientsIdParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdInfiniteQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsId>>> = ({ signal }) =>
    getClientsId(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getClientsId>>>;
export type GetClientsIdInfiniteQueryError = unknown;

export function useGetClientsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsId>>>,
  TError = unknown,
>(
  id: string,
  params: undefined | GetClientsIdParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsId>>,
          TError,
          Awaited<ReturnType<typeof getClientsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsId>>>,
  TError = unknown,
>(
  id: string,
  params?: GetClientsIdParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsId>>,
          TError,
          Awaited<ReturnType<typeof getClientsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsId>>>,
  TError = unknown,
>(
  id: string,
  params?: GetClientsIdParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get client
 */

export function useGetClientsIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsId>>>,
  TError = unknown,
>(
  id: string,
  params?: GetClientsIdParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdInfiniteQueryOptions(id, params, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsId>>,
  TError = unknown,
>(
  id: string,
  params?: GetClientsIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsId>>> = ({ signal }) =>
    getClientsId(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getClientsId>>>;
export type GetClientsIdQueryError = unknown;

export function useGetClientsId<TData = Awaited<ReturnType<typeof getClientsId>>, TError = unknown>(
  id: string,
  params: undefined | GetClientsIdParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsId>>,
          TError,
          Awaited<ReturnType<typeof getClientsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsId<TData = Awaited<ReturnType<typeof getClientsId>>, TError = unknown>(
  id: string,
  params?: GetClientsIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsId>>,
          TError,
          Awaited<ReturnType<typeof getClientsId>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsId<TData = Awaited<ReturnType<typeof getClientsId>>, TError = unknown>(
  id: string,
  params?: GetClientsIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get client
 */

export function useGetClientsId<TData = Awaited<ReturnType<typeof getClientsId>>, TError = unknown>(
  id: string,
  params?: GetClientsIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsId>>,
  TError = unknown,
>(
  id: string,
  params?: GetClientsIdParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsId>>> = ({ signal }) =>
    getClientsId(id, params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getClientsId>>>;
export type GetClientsIdSuspenseQueryError = unknown;

export function useGetClientsIdSuspense<
  TData = Awaited<ReturnType<typeof getClientsId>>,
  TError = unknown,
>(
  id: string,
  params: undefined | GetClientsIdParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdSuspense<
  TData = Awaited<ReturnType<typeof getClientsId>>,
  TError = unknown,
>(
  id: string,
  params?: GetClientsIdParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdSuspense<
  TData = Awaited<ReturnType<typeof getClientsId>>,
  TError = unknown,
>(
  id: string,
  params?: GetClientsIdParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get client
 */

export function useGetClientsIdSuspense<
  TData = Awaited<ReturnType<typeof getClientsId>>,
  TError = unknown,
>(
  id: string,
  params?: GetClientsIdParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a client (partial update)
 * @summary Update client
 */
export const patchClientsId = (id: string, patchClientsIdBody: PatchClientsIdBody) => {
  return customInstance<PatchClientsId200>({
    url: `/clients/${id}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: patchClientsIdBody,
  });
};

export const getPatchClientsIdMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchClientsId>>,
    TError,
    { id: string; data: PatchClientsIdBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchClientsId>>,
  TError,
  { id: string; data: PatchClientsIdBody },
  TContext
> => {
  const mutationKey = ['patchClientsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchClientsId>>,
    { id: string; data: PatchClientsIdBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return patchClientsId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchClientsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchClientsId>>>;
export type PatchClientsIdMutationBody = PatchClientsIdBody;
export type PatchClientsIdMutationError = unknown;

/**
 * @summary Update client
 */
export const usePatchClientsId = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchClientsId>>,
      TError,
      { id: string; data: PatchClientsIdBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof patchClientsId>>,
  TError,
  { id: string; data: PatchClientsIdBody },
  TContext
> => {
  const mutationOptions = getPatchClientsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Archive a client (sets isActive=false and deletedAt); history is kept. Requires salon admin, agency access, or the "Can delete and merge clients" permission.
 * @summary Delete client
 */
export const deleteClientsId = (id: string) => {
  return customInstance<DeleteClientsId200>({ url: `/clients/${id}`, method: 'DELETE' });
};

export const getDeleteClientsIdMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteClientsId>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteClientsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['deleteClientsId'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteClientsId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteClientsId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteClientsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteClientsId>>
>;

export type DeleteClientsIdMutationError = void;

/**
 * @summary Delete client
 */
export const useDeleteClientsId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteClientsId>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteClientsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getDeleteClientsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * The target client (URL param) is the survivor: it keeps its own name and every field it already has, blank profile fields are filled from the source, and all history (appointments, sales, notes, files, cards, gift cards, packages, memberships, wallet, conversations, marketing records) moves to it. The source client (body) is archived. Requires salon admin, agency access, or the "Can delete and merge clients" permission.
 * @summary Merge another client into this client
 */
export const postClientsIdMerge = (
  id: string,
  postClientsIdMergeBody: PostClientsIdMergeBody,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsIdMerge200>({
    url: `/clients/${id}/merge`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsIdMergeBody,
    signal,
  });
};

export const getPostClientsIdMergeMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsIdMerge>>,
    TError,
    { id: string; data: PostClientsIdMergeBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsIdMerge>>,
  TError,
  { id: string; data: PostClientsIdMergeBody },
  TContext
> => {
  const mutationKey = ['postClientsIdMerge'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsIdMerge>>,
    { id: string; data: PostClientsIdMergeBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postClientsIdMerge(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsIdMergeMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsIdMerge>>
>;
export type PostClientsIdMergeMutationBody = PostClientsIdMergeBody;
export type PostClientsIdMergeMutationError = void;

/**
 * @summary Merge another client into this client
 */
export const usePostClientsIdMerge = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsIdMerge>>,
      TError,
      { id: string; data: PostClientsIdMergeBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsIdMerge>>,
  TError,
  { id: string; data: PostClientsIdMergeBody },
  TContext
> => {
  const mutationOptions = getPostClientsIdMergeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * The client's own visits and attached lead sign-ups (newest first, bounded), each flagged `suggested` when booked or signed up under a different first name. Same permission as Merge.
 * @summary Visits and sign-ups a split could move
 */
export const getClientsIdSplitCandidates = (id: string, signal?: AbortSignal) => {
  return customInstance<GetClientsIdSplitCandidates200>({
    url: `/clients/${id}/split-candidates`,
    method: 'GET',
    signal,
  });
};

export const getGetClientsIdSplitCandidatesInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/clients/${id}/split-candidates`] as const;
};

export const getGetClientsIdSplitCandidatesQueryKey = (id?: string) => {
  return [`/clients/${id}/split-candidates`] as const;
};

export const getGetClientsIdSplitCandidatesInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdSplitCandidatesInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>> = ({
    signal,
  }) => getClientsIdSplitCandidates(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdSplitCandidatesInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdSplitCandidates>>
>;
export type GetClientsIdSplitCandidatesInfiniteQueryError = void;

export function useGetClientsIdSplitCandidatesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdSplitCandidates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdSplitCandidatesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdSplitCandidates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdSplitCandidatesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Visits and sign-ups a split could move
 */

export function useGetClientsIdSplitCandidatesInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdSplitCandidatesInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdSplitCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdSplitCandidatesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>> = ({
    signal,
  }) => getClientsIdSplitCandidates(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdSplitCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdSplitCandidates>>
>;
export type GetClientsIdSplitCandidatesQueryError = void;

export function useGetClientsIdSplitCandidates<
  TData = Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdSplitCandidates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdSplitCandidates<
  TData = Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdSplitCandidates>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdSplitCandidates<
  TData = Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Visits and sign-ups a split could move
 */

export function useGetClientsIdSplitCandidates<
  TData = Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdSplitCandidatesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdSplitCandidatesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdSplitCandidatesQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdSplitCandidates>>> = ({
    signal,
  }) => getClientsIdSplitCandidates(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdSplitCandidatesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdSplitCandidates>>
>;
export type GetClientsIdSplitCandidatesSuspenseQueryError = void;

export function useGetClientsIdSplitCandidatesSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdSplitCandidatesSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdSplitCandidatesSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Visits and sign-ups a split could move
 */

export function useGetClientsIdSplitCandidatesSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsIdSplitCandidates>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdSplitCandidatesSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates a new profile on the same phone (a household) and moves the chosen visits (with their sales, reminders and review requests) and lead sign-ups (with their New Client Offer claim) to it. Gift cards, notes, messages and cards stay. Reversible with Merge. Same permission as Merge.
 * @summary Split into separate profile
 */
export const postClientsIdSplit = (
  id: string,
  postClientsIdSplitBody: PostClientsIdSplitBody,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsIdSplit200>({
    url: `/clients/${id}/split`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsIdSplitBody,
    signal,
  });
};

export const getPostClientsIdSplitMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsIdSplit>>,
    TError,
    { id: string; data: PostClientsIdSplitBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsIdSplit>>,
  TError,
  { id: string; data: PostClientsIdSplitBody },
  TContext
> => {
  const mutationKey = ['postClientsIdSplit'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsIdSplit>>,
    { id: string; data: PostClientsIdSplitBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postClientsIdSplit(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsIdSplitMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsIdSplit>>
>;
export type PostClientsIdSplitMutationBody = PostClientsIdSplitBody;
export type PostClientsIdSplitMutationError = void;

/**
 * @summary Split into separate profile
 */
export const usePostClientsIdSplit = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsIdSplit>>,
      TError,
      { id: string; data: PostClientsIdSplitBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsIdSplit>>,
  TError,
  { id: string; data: PostClientsIdSplitBody },
  TContext
> => {
  const mutationOptions = getPostClientsIdSplitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * No-show protection, New Appointment form: the card a desk booking for this client would be secured with (only cards the client added through their own texted link), and whether a card link can be texted instead. Salon staff with booking permission only; agency members get 403.
 * @summary Client's reusable card for desk bookings
 */
export const getClientsIdCardOnFile = (id: string, signal?: AbortSignal) => {
  return customInstance<GetClientsIdCardOnFile200>({
    url: `/clients/${id}/card-on-file`,
    method: 'GET',
    signal,
  });
};

export const getGetClientsIdCardOnFileInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/clients/${id}/card-on-file`] as const;
};

export const getGetClientsIdCardOnFileQueryKey = (id?: string) => {
  return [`/clients/${id}/card-on-file`] as const;
};

export const getGetClientsIdCardOnFileInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCardOnFile>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdCardOnFileInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdCardOnFile>>> = ({ signal }) =>
    getClientsIdCardOnFile(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdCardOnFileInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdCardOnFile>>
>;
export type GetClientsIdCardOnFileInfiniteQueryError = void;

export function useGetClientsIdCardOnFileInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCardOnFile>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdCardOnFile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCardOnFileInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCardOnFile>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdCardOnFile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCardOnFileInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCardOnFile>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Client's reusable card for desk bookings
 */

export function useGetClientsIdCardOnFileInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCardOnFile>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdCardOnFileInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdCardOnFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdCardOnFileQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdCardOnFile>>> = ({ signal }) =>
    getClientsIdCardOnFile(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdCardOnFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdCardOnFile>>
>;
export type GetClientsIdCardOnFileQueryError = void;

export function useGetClientsIdCardOnFile<
  TData = Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdCardOnFile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCardOnFile<
  TData = Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdCardOnFile>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCardOnFile<
  TData = Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Client's reusable card for desk bookings
 */

export function useGetClientsIdCardOnFile<
  TData = Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdCardOnFileQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdCardOnFileSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdCardOnFileQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdCardOnFile>>> = ({ signal }) =>
    getClientsIdCardOnFile(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdCardOnFileSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdCardOnFile>>
>;
export type GetClientsIdCardOnFileSuspenseQueryError = void;

export function useGetClientsIdCardOnFileSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCardOnFileSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCardOnFileSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Client's reusable card for desk bookings
 */

export function useGetClientsIdCardOnFileSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdCardOnFile>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCardOnFile>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdCardOnFileSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Cards owned by the client OR (no owner AND purchased by the client). Includes usableCount (balance > 0).
 * @summary List a client's usable gift cards
 */
export const getClientsClientIdGiftCards = (clientId: string, signal?: AbortSignal) => {
  return customInstance<GetClientsClientIdGiftCards200>({
    url: `/clients/${clientId}/gift-cards`,
    method: 'GET',
    signal,
  });
};

export const getGetClientsClientIdGiftCardsInfiniteQueryKey = (clientId?: string) => {
  return ['infinite', `/clients/${clientId}/gift-cards`] as const;
};

export const getGetClientsClientIdGiftCardsQueryKey = (clientId?: string) => {
  return [`/clients/${clientId}/gift-cards`] as const;
};

export const getGetClientsClientIdGiftCardsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetClientsClientIdGiftCardsInfiniteQueryKey(clientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>> = ({
    signal,
  }) => getClientsClientIdGiftCards(clientId, signal);

  return { queryKey, queryFn, enabled: !!clientId, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsClientIdGiftCardsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsClientIdGiftCards>>
>;
export type GetClientsClientIdGiftCardsInfiniteQueryError = unknown;

export function useGetClientsClientIdGiftCardsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>>,
  TError = unknown,
>(
  clientId: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
          TError,
          Awaited<ReturnType<typeof getClientsClientIdGiftCards>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsClientIdGiftCardsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
          TError,
          Awaited<ReturnType<typeof getClientsClientIdGiftCards>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsClientIdGiftCardsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List a client's usable gift cards
 */

export function useGetClientsClientIdGiftCardsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsClientIdGiftCardsInfiniteQueryOptions(clientId, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsClientIdGiftCardsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsClientIdGiftCardsQueryKey(clientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>> = ({
    signal,
  }) => getClientsClientIdGiftCards(clientId, signal);

  return { queryKey, queryFn, enabled: !!clientId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsClientIdGiftCardsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsClientIdGiftCards>>
>;
export type GetClientsClientIdGiftCardsQueryError = unknown;

export function useGetClientsClientIdGiftCards<
  TData = Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
  TError = unknown,
>(
  clientId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
          TError,
          Awaited<ReturnType<typeof getClientsClientIdGiftCards>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsClientIdGiftCards<
  TData = Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
          TError,
          Awaited<ReturnType<typeof getClientsClientIdGiftCards>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsClientIdGiftCards<
  TData = Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List a client's usable gift cards
 */

export function useGetClientsClientIdGiftCards<
  TData = Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsClientIdGiftCardsQueryOptions(clientId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsClientIdGiftCardsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsClientIdGiftCardsQueryKey(clientId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsClientIdGiftCards>>> = ({
    signal,
  }) => getClientsClientIdGiftCards(clientId, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsClientIdGiftCardsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsClientIdGiftCards>>
>;
export type GetClientsClientIdGiftCardsSuspenseQueryError = unknown;

export function useGetClientsClientIdGiftCardsSuspense<
  TData = Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
  TError = unknown,
>(
  clientId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsClientIdGiftCardsSuspense<
  TData = Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsClientIdGiftCardsSuspense<
  TData = Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List a client's usable gift cards
 */

export function useGetClientsClientIdGiftCardsSuspense<
  TData = Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
  TError = unknown,
>(
  clientId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof getClientsClientIdGiftCards>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsClientIdGiftCardsSuspenseQueryOptions(clientId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Google review status for the client drawer (asked / tapped / reviewed + whether staff can send now)
 */
export const getClientsIdReviewStatus = (id: string, signal?: AbortSignal) => {
  return customInstance<GetClientsIdReviewStatus200>({
    url: `/clients/${id}/review-status`,
    method: 'GET',
    signal,
  });
};

export const getGetClientsIdReviewStatusInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/clients/${id}/review-status`] as const;
};

export const getGetClientsIdReviewStatusQueryKey = (id?: string) => {
  return [`/clients/${id}/review-status`] as const;
};

export const getGetClientsIdReviewStatusInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdReviewStatus>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdReviewStatusInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdReviewStatus>>> = ({
    signal,
  }) => getClientsIdReviewStatus(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdReviewStatusInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdReviewStatus>>
>;
export type GetClientsIdReviewStatusInfiniteQueryError = void;

export function useGetClientsIdReviewStatusInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdReviewStatus>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdReviewStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdReviewStatusInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdReviewStatus>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdReviewStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdReviewStatusInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdReviewStatus>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Google review status for the client drawer (asked / tapped / reviewed + whether staff can send now)
 */

export function useGetClientsIdReviewStatusInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdReviewStatus>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdReviewStatusInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdReviewStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdReviewStatusQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdReviewStatus>>> = ({
    signal,
  }) => getClientsIdReviewStatus(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdReviewStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdReviewStatus>>
>;
export type GetClientsIdReviewStatusQueryError = void;

export function useGetClientsIdReviewStatus<
  TData = Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdReviewStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdReviewStatus<
  TData = Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdReviewStatus>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdReviewStatus<
  TData = Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Google review status for the client drawer (asked / tapped / reviewed + whether staff can send now)
 */

export function useGetClientsIdReviewStatus<
  TData = Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdReviewStatusQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdReviewStatusSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdReviewStatusQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdReviewStatus>>> = ({
    signal,
  }) => getClientsIdReviewStatus(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdReviewStatusSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdReviewStatus>>
>;
export type GetClientsIdReviewStatusSuspenseQueryError = void;

export function useGetClientsIdReviewStatusSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdReviewStatusSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdReviewStatusSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Google review status for the client drawer (asked / tapped / reviewed + whether staff can send now)
 */

export function useGetClientsIdReviewStatusSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdReviewStatus>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdReviewStatus>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdReviewStatusSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Send this client a Google review request now (scheduled into the 9:00–20:00 window)
 */
export const postClientsIdReviewRequest = (
  id: string,
  postClientsIdReviewRequestBody: PostClientsIdReviewRequestBody,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsIdReviewRequest200>({
    url: `/clients/${id}/review-request`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsIdReviewRequestBody,
    signal,
  });
};

export const getPostClientsIdReviewRequestMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsIdReviewRequest>>,
    TError,
    { id: string; data: PostClientsIdReviewRequestBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsIdReviewRequest>>,
  TError,
  { id: string; data: PostClientsIdReviewRequestBody },
  TContext
> => {
  const mutationKey = ['postClientsIdReviewRequest'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsIdReviewRequest>>,
    { id: string; data: PostClientsIdReviewRequestBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postClientsIdReviewRequest(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsIdReviewRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsIdReviewRequest>>
>;
export type PostClientsIdReviewRequestMutationBody = PostClientsIdReviewRequestBody;
export type PostClientsIdReviewRequestMutationError = void;

/**
 * @summary Send this client a Google review request now (scheduled into the 9:00–20:00 window)
 */
export const usePostClientsIdReviewRequest = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsIdReviewRequest>>,
      TError,
      { id: string; data: PostClientsIdReviewRequestBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsIdReviewRequest>>,
  TError,
  { id: string; data: PostClientsIdReviewRequestBody },
  TContext
> => {
  const mutationOptions = getPostClientsIdReviewRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Refer a Friend card for the client drawer (referred by, friends, rewards, invite link)
 */
export const getClientsIdReferrals = (id: string, signal?: AbortSignal) => {
  return customInstance<GetClientsIdReferrals200>({
    url: `/clients/${id}/referrals`,
    method: 'GET',
    signal,
  });
};

export const getGetClientsIdReferralsInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/clients/${id}/referrals`] as const;
};

export const getGetClientsIdReferralsQueryKey = (id?: string) => {
  return [`/clients/${id}/referrals`] as const;
};

export const getGetClientsIdReferralsInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdReferrals>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdReferralsInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdReferrals>>> = ({ signal }) =>
    getClientsIdReferrals(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsIdReferrals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdReferralsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdReferrals>>
>;
export type GetClientsIdReferralsInfiniteQueryError = void;

export function useGetClientsIdReferralsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdReferrals>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdReferrals>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdReferrals>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdReferralsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdReferrals>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdReferrals>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdReferrals>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdReferralsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdReferrals>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Refer a Friend card for the client drawer (referred by, friends, rewards, invite link)
 */

export function useGetClientsIdReferralsInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdReferrals>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdReferralsInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdReferralsQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdReferrals>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdReferralsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdReferrals>>> = ({ signal }) =>
    getClientsIdReferrals(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdReferrals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdReferralsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdReferrals>>
>;
export type GetClientsIdReferralsQueryError = void;

export function useGetClientsIdReferrals<
  TData = Awaited<ReturnType<typeof getClientsIdReferrals>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdReferrals>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdReferrals>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdReferrals<
  TData = Awaited<ReturnType<typeof getClientsIdReferrals>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdReferrals>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdReferrals>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdReferrals<
  TData = Awaited<ReturnType<typeof getClientsIdReferrals>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Refer a Friend card for the client drawer (referred by, friends, rewards, invite link)
 */

export function useGetClientsIdReferrals<
  TData = Awaited<ReturnType<typeof getClientsIdReferrals>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdReferralsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdReferralsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdReferrals>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdReferralsQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdReferrals>>> = ({ signal }) =>
    getClientsIdReferrals(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdReferrals>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdReferralsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdReferrals>>
>;
export type GetClientsIdReferralsSuspenseQueryError = void;

export function useGetClientsIdReferralsSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdReferrals>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdReferralsSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdReferrals>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdReferralsSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdReferrals>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Refer a Friend card for the client drawer (referred by, friends, rewards, invite link)
 */

export function useGetClientsIdReferralsSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdReferrals>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdReferrals>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdReferralsSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add who referred this client by hand (verbal referral at the desk)
 */
export const postClientsIdReferrer = (
  id: string,
  postClientsIdReferrerBody: PostClientsIdReferrerBody,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsIdReferrer200>({
    url: `/clients/${id}/referrer`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postClientsIdReferrerBody,
    signal,
  });
};

export const getPostClientsIdReferrerMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsIdReferrer>>,
    TError,
    { id: string; data: PostClientsIdReferrerBody },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsIdReferrer>>,
  TError,
  { id: string; data: PostClientsIdReferrerBody },
  TContext
> => {
  const mutationKey = ['postClientsIdReferrer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsIdReferrer>>,
    { id: string; data: PostClientsIdReferrerBody }
  > = (props) => {
    const { id, data } = props ?? {};

    return postClientsIdReferrer(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsIdReferrerMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsIdReferrer>>
>;
export type PostClientsIdReferrerMutationBody = PostClientsIdReferrerBody;
export type PostClientsIdReferrerMutationError = void;

/**
 * @summary Add who referred this client by hand (verbal referral at the desk)
 */
export const usePostClientsIdReferrer = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsIdReferrer>>,
      TError,
      { id: string; data: PostClientsIdReferrerBody },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsIdReferrer>>,
  TError,
  { id: string; data: PostClientsIdReferrerBody },
  TContext
> => {
  const mutationOptions = getPostClientsIdReferrerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary The beauty creator this client came from, for the client drawer "Came from" row (display only)
 */
export const getClientsIdCreator = (id: string, signal?: AbortSignal) => {
  return customInstance<GetClientsIdCreator200>({
    url: `/clients/${id}/creator`,
    method: 'GET',
    signal,
  });
};

export const getGetClientsIdCreatorInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/clients/${id}/creator`] as const;
};

export const getGetClientsIdCreatorQueryKey = (id?: string) => {
  return [`/clients/${id}/creator`] as const;
};

export const getGetClientsIdCreatorInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCreator>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdCreatorInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdCreator>>> = ({ signal }) =>
    getClientsIdCreator(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsIdCreator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdCreatorInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdCreator>>
>;
export type GetClientsIdCreatorInfiniteQueryError = void;

export function useGetClientsIdCreatorInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCreator>>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdCreator>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdCreator>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCreatorInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCreator>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdCreator>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdCreator>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCreatorInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCreator>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The beauty creator this client came from, for the client drawer "Came from" row (display only)
 */

export function useGetClientsIdCreatorInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCreator>>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdCreatorInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdCreatorQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdCreator>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdCreatorQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdCreator>>> = ({ signal }) =>
    getClientsIdCreator(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdCreator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdCreatorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdCreator>>
>;
export type GetClientsIdCreatorQueryError = void;

export function useGetClientsIdCreator<
  TData = Awaited<ReturnType<typeof getClientsIdCreator>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdCreator>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdCreator>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCreator<
  TData = Awaited<ReturnType<typeof getClientsIdCreator>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdCreator>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdCreator>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCreator<
  TData = Awaited<ReturnType<typeof getClientsIdCreator>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The beauty creator this client came from, for the client drawer "Came from" row (display only)
 */

export function useGetClientsIdCreator<
  TData = Awaited<ReturnType<typeof getClientsIdCreator>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdCreatorQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdCreatorSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdCreator>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdCreatorQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdCreator>>> = ({ signal }) =>
    getClientsIdCreator(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdCreator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdCreatorSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdCreator>>
>;
export type GetClientsIdCreatorSuspenseQueryError = void;

export function useGetClientsIdCreatorSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdCreator>>,
  TError = void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCreatorSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdCreator>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCreatorSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdCreator>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The beauty creator this client came from, for the client drawer "Came from" row (display only)
 */

export function useGetClientsIdCreatorSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdCreator>>,
  TError = void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCreator>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdCreatorSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary The client's counter-sign perks (offer, this month's prize, referral reward) for the desk's "Used at the counter"
 */
export const getClientsIdCounterPerks = (id: string, signal?: AbortSignal) => {
  return customInstance<GetClientsIdCounterPerks200>({
    url: `/clients/${id}/counter-perks`,
    method: 'GET',
    signal,
  });
};

export const getGetClientsIdCounterPerksInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/clients/${id}/counter-perks`] as const;
};

export const getGetClientsIdCounterPerksQueryKey = (id?: string) => {
  return [`/clients/${id}/counter-perks`] as const;
};

export const getGetClientsIdCounterPerksInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCounterPerks>>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdCounterPerksInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdCounterPerks>>> = ({
    signal,
  }) => getClientsIdCounterPerks(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdCounterPerksInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdCounterPerks>>
>;
export type GetClientsIdCounterPerksInfiniteQueryError = GetClientsIdCounterPerks403 | void;

export function useGetClientsIdCounterPerksInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCounterPerks>>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdCounterPerks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCounterPerksInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCounterPerks>>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdCounterPerks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCounterPerksInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCounterPerks>>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The client's counter-sign perks (offer, this month's prize, referral reward) for the desk's "Used at the counter"
 */

export function useGetClientsIdCounterPerksInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdCounterPerks>>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdCounterPerksInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdCounterPerksQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdCounterPerksQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdCounterPerks>>> = ({
    signal,
  }) => getClientsIdCounterPerks(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdCounterPerksQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdCounterPerks>>
>;
export type GetClientsIdCounterPerksQueryError = GetClientsIdCounterPerks403 | void;

export function useGetClientsIdCounterPerks<
  TData = Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdCounterPerks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCounterPerks<
  TData = Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdCounterPerks>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCounterPerks<
  TData = Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The client's counter-sign perks (offer, this month's prize, referral reward) for the desk's "Used at the counter"
 */

export function useGetClientsIdCounterPerks<
  TData = Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdCounterPerksQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdCounterPerksSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdCounterPerksQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdCounterPerks>>> = ({
    signal,
  }) => getClientsIdCounterPerks(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdCounterPerksSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdCounterPerks>>
>;
export type GetClientsIdCounterPerksSuspenseQueryError = GetClientsIdCounterPerks403 | void;

export function useGetClientsIdCounterPerksSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCounterPerksSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdCounterPerksSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The client's counter-sign perks (offer, this month's prize, referral reward) for the desk's "Used at the counter"
 */

export function useGetClientsIdCounterPerksSuspense<
  TData = Awaited<ReturnType<typeof getClientsIdCounterPerks>>,
  TError = GetClientsIdCounterPerks403 | void,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdCounterPerks>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdCounterPerksSuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Used at the counter: record the client's ready perk as a counter-sign use by this staff member. Already used today is a no-op. `loyalty` uses the Rewards card reward (any check-in mode, one per salon day).
 */
export const postClientsIdCounterPerksKindUse = (
  id: string,
  kind: 'offer' | 'prize' | 'referral' | 'loyalty',
  params?: PostClientsIdCounterPerksKindUseParams,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsIdCounterPerksKindUse200>({
    url: `/clients/${id}/counter-perks/${kind}/use`,
    method: 'POST',
    params,
    signal,
  });
};

export const getPostClientsIdCounterPerksKindUseMutationOptions = <
  TError = PostClientsIdCounterPerksKindUse403 | void | PostClientsIdCounterPerksKindUse409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsIdCounterPerksKindUse>>,
    TError,
    {
      id: string;
      kind: 'offer' | 'prize' | 'referral' | 'loyalty';
      params?: PostClientsIdCounterPerksKindUseParams;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsIdCounterPerksKindUse>>,
  TError,
  {
    id: string;
    kind: 'offer' | 'prize' | 'referral' | 'loyalty';
    params?: PostClientsIdCounterPerksKindUseParams;
  },
  TContext
> => {
  const mutationKey = ['postClientsIdCounterPerksKindUse'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsIdCounterPerksKindUse>>,
    {
      id: string;
      kind: 'offer' | 'prize' | 'referral' | 'loyalty';
      params?: PostClientsIdCounterPerksKindUseParams;
    }
  > = (props) => {
    const { id, kind, params } = props ?? {};

    return postClientsIdCounterPerksKindUse(id, kind, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsIdCounterPerksKindUseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsIdCounterPerksKindUse>>
>;

export type PostClientsIdCounterPerksKindUseMutationError =
  | PostClientsIdCounterPerksKindUse403
  | void
  | PostClientsIdCounterPerksKindUse409;

/**
 * @summary Used at the counter: record the client's ready perk as a counter-sign use by this staff member. Already used today is a no-op. `loyalty` uses the Rewards card reward (any check-in mode, one per salon day).
 */
export const usePostClientsIdCounterPerksKindUse = <
  TError = PostClientsIdCounterPerksKindUse403 | void | PostClientsIdCounterPerksKindUse409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsIdCounterPerksKindUse>>,
      TError,
      {
        id: string;
        kind: 'offer' | 'prize' | 'referral' | 'loyalty';
        params?: PostClientsIdCounterPerksKindUseParams;
      },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsIdCounterPerksKindUse>>,
  TError,
  {
    id: string;
    kind: 'offer' | 'prize' | 'referral' | 'loyalty';
    params?: PostClientsIdCounterPerksKindUseParams;
  },
  TContext
> => {
  const mutationOptions = getPostClientsIdCounterPerksKindUseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary The client's Rewards card at the desk: progress, ready rewards and stamp history with Undo
 */
export const getClientsIdLoyalty = (id: string, signal?: AbortSignal) => {
  return customInstance<GetClientsIdLoyalty200>({
    url: `/clients/${id}/loyalty`,
    method: 'GET',
    signal,
  });
};

export const getGetClientsIdLoyaltyInfiniteQueryKey = (id?: string) => {
  return ['infinite', `/clients/${id}/loyalty`] as const;
};

export const getGetClientsIdLoyaltyQueryKey = (id?: string) => {
  return [`/clients/${id}/loyalty`] as const;
};

export const getGetClientsIdLoyaltyInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdLoyalty>>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdLoyaltyInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdLoyalty>>> = ({ signal }) =>
    getClientsIdLoyalty(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getClientsIdLoyalty>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdLoyaltyInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdLoyalty>>
>;
export type GetClientsIdLoyaltyInfiniteQueryError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404;

export function useGetClientsIdLoyaltyInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdLoyalty>>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdLoyalty>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdLoyalty>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdLoyaltyInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdLoyalty>>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdLoyalty>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdLoyalty>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdLoyaltyInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdLoyalty>>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The client's Rewards card at the desk: progress, ready rewards and stamp history with Undo
 */

export function useGetClientsIdLoyaltyInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getClientsIdLoyalty>>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdLoyaltyInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(queryOptions, queryClient) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdLoyaltyQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdLoyalty>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdLoyaltyQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdLoyalty>>> = ({ signal }) =>
    getClientsIdLoyalty(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdLoyalty>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdLoyaltyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdLoyalty>>
>;
export type GetClientsIdLoyaltyQueryError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404;

export function useGetClientsIdLoyalty<
  TData = Awaited<ReturnType<typeof getClientsIdLoyalty>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdLoyalty>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdLoyalty>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdLoyalty<
  TData = Awaited<ReturnType<typeof getClientsIdLoyalty>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientsIdLoyalty>>,
          TError,
          Awaited<ReturnType<typeof getClientsIdLoyalty>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdLoyalty<
  TData = Awaited<ReturnType<typeof getClientsIdLoyalty>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The client's Rewards card at the desk: progress, ready rewards and stamp history with Undo
 */

export function useGetClientsIdLoyalty<
  TData = Awaited<ReturnType<typeof getClientsIdLoyalty>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdLoyaltyQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetClientsIdLoyaltySuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getClientsIdLoyalty>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetClientsIdLoyaltyQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientsIdLoyalty>>> = ({ signal }) =>
    getClientsIdLoyalty(id, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getClientsIdLoyalty>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetClientsIdLoyaltySuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getClientsIdLoyalty>>
>;
export type GetClientsIdLoyaltySuspenseQueryError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404;

export function useGetClientsIdLoyaltySuspense<
  TData = Awaited<ReturnType<typeof getClientsIdLoyalty>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdLoyaltySuspense<
  TData = Awaited<ReturnType<typeof getClientsIdLoyalty>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetClientsIdLoyaltySuspense<
  TData = Awaited<ReturnType<typeof getClientsIdLoyalty>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The client's Rewards card at the desk: progress, ready rewards and stamp history with Undo
 */

export function useGetClientsIdLoyaltySuspense<
  TData = Awaited<ReturnType<typeof getClientsIdLoyalty>>,
  TError = GetClientsIdLoyalty403 | GetClientsIdLoyalty404,
>(
  id: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof getClientsIdLoyalty>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetClientsIdLoyaltySuspenseQueryOptions(id, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add today's visit stamp from the desk (client forgot to tap). Already stamped today is a 200 with ALREADY_TODAY.
 */
export const postClientsIdLoyaltyStamps = (id: string, signal?: AbortSignal) => {
  return customInstance<PostClientsIdLoyaltyStamps200>({
    url: `/clients/${id}/loyalty/stamps`,
    method: 'POST',
    signal,
  });
};

export const getPostClientsIdLoyaltyStampsMutationOptions = <
  TError =
    | PostClientsIdLoyaltyStamps403
    | PostClientsIdLoyaltyStamps404
    | PostClientsIdLoyaltyStamps409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsIdLoyaltyStamps>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsIdLoyaltyStamps>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['postClientsIdLoyaltyStamps'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsIdLoyaltyStamps>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postClientsIdLoyaltyStamps(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsIdLoyaltyStampsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsIdLoyaltyStamps>>
>;

export type PostClientsIdLoyaltyStampsMutationError =
  | PostClientsIdLoyaltyStamps403
  | PostClientsIdLoyaltyStamps404
  | PostClientsIdLoyaltyStamps409;

/**
 * @summary Add today's visit stamp from the desk (client forgot to tap). Already stamped today is a 200 with ALREADY_TODAY.
 */
export const usePostClientsIdLoyaltyStamps = <
  TError =
    | PostClientsIdLoyaltyStamps403
    | PostClientsIdLoyaltyStamps404
    | PostClientsIdLoyaltyStamps409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsIdLoyaltyStamps>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsIdLoyaltyStamps>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getPostClientsIdLoyaltyStampsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Take back a visit stamp (admins any time, checkout staff the same salon day). A repeat is a no-op.
 */
export const postClientsIdLoyaltyStampsStampIdUndo = (
  id: string,
  stampId: string,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsIdLoyaltyStampsStampIdUndo200>({
    url: `/clients/${id}/loyalty/stamps/${stampId}/undo`,
    method: 'POST',
    signal,
  });
};

export const getPostClientsIdLoyaltyStampsStampIdUndoMutationOptions = <
  TError =
    | PostClientsIdLoyaltyStampsStampIdUndo403
    | PostClientsIdLoyaltyStampsStampIdUndo404
    | PostClientsIdLoyaltyStampsStampIdUndo409,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsIdLoyaltyStampsStampIdUndo>>,
    TError,
    { id: string; stampId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsIdLoyaltyStampsStampIdUndo>>,
  TError,
  { id: string; stampId: string },
  TContext
> => {
  const mutationKey = ['postClientsIdLoyaltyStampsStampIdUndo'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsIdLoyaltyStampsStampIdUndo>>,
    { id: string; stampId: string }
  > = (props) => {
    const { id, stampId } = props ?? {};

    return postClientsIdLoyaltyStampsStampIdUndo(id, stampId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsIdLoyaltyStampsStampIdUndoMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsIdLoyaltyStampsStampIdUndo>>
>;

export type PostClientsIdLoyaltyStampsStampIdUndoMutationError =
  | PostClientsIdLoyaltyStampsStampIdUndo403
  | PostClientsIdLoyaltyStampsStampIdUndo404
  | PostClientsIdLoyaltyStampsStampIdUndo409;

/**
 * @summary Take back a visit stamp (admins any time, checkout staff the same salon day). A repeat is a no-op.
 */
export const usePostClientsIdLoyaltyStampsStampIdUndo = <
  TError =
    | PostClientsIdLoyaltyStampsStampIdUndo403
    | PostClientsIdLoyaltyStampsStampIdUndo404
    | PostClientsIdLoyaltyStampsStampIdUndo409,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsIdLoyaltyStampsStampIdUndo>>,
      TError,
      { id: string; stampId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsIdLoyaltyStampsStampIdUndo>>,
  TError,
  { id: string; stampId: string },
  TContext
> => {
  const mutationOptions = getPostClientsIdLoyaltyStampsStampIdUndoMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Take back a reward use (the reward is ready again until it ends). A repeat is a no-op.
 */
export const postClientsIdLoyaltyRewardsRewardIdUndoUse = (
  id: string,
  rewardId: string,
  signal?: AbortSignal
) => {
  return customInstance<PostClientsIdLoyaltyRewardsRewardIdUndoUse200>({
    url: `/clients/${id}/loyalty/rewards/${rewardId}/undo-use`,
    method: 'POST',
    signal,
  });
};

export const getPostClientsIdLoyaltyRewardsRewardIdUndoUseMutationOptions = <
  TError =
    | PostClientsIdLoyaltyRewardsRewardIdUndoUse403
    | PostClientsIdLoyaltyRewardsRewardIdUndoUse404,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postClientsIdLoyaltyRewardsRewardIdUndoUse>>,
    TError,
    { id: string; rewardId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postClientsIdLoyaltyRewardsRewardIdUndoUse>>,
  TError,
  { id: string; rewardId: string },
  TContext
> => {
  const mutationKey = ['postClientsIdLoyaltyRewardsRewardIdUndoUse'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postClientsIdLoyaltyRewardsRewardIdUndoUse>>,
    { id: string; rewardId: string }
  > = (props) => {
    const { id, rewardId } = props ?? {};

    return postClientsIdLoyaltyRewardsRewardIdUndoUse(id, rewardId);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostClientsIdLoyaltyRewardsRewardIdUndoUseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postClientsIdLoyaltyRewardsRewardIdUndoUse>>
>;

export type PostClientsIdLoyaltyRewardsRewardIdUndoUseMutationError =
  | PostClientsIdLoyaltyRewardsRewardIdUndoUse403
  | PostClientsIdLoyaltyRewardsRewardIdUndoUse404;

/**
 * @summary Take back a reward use (the reward is ready again until it ends). A repeat is a no-op.
 */
export const usePostClientsIdLoyaltyRewardsRewardIdUndoUse = <
  TError =
    | PostClientsIdLoyaltyRewardsRewardIdUndoUse403
    | PostClientsIdLoyaltyRewardsRewardIdUndoUse404,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postClientsIdLoyaltyRewardsRewardIdUndoUse>>,
      TError,
      { id: string; rewardId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postClientsIdLoyaltyRewardsRewardIdUndoUse>>,
  TError,
  { id: string; rewardId: string },
  TContext
> => {
  const mutationOptions = getPostClientsIdLoyaltyRewardsRewardIdUndoUseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
